const dateUtils = {
  _getDateOrdinal(day: number) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  },
  formatDayWithOrdinal(date: Date) {
    const day = date.getDate();
    return day + dateUtils._getDateOrdinal(day);
  },
  formatMonthStrDayStr(date: Date) {
    // ex: Mar 3rd
    const monthStr = date.toLocaleString('default', {
      // @ts-ignore
      month: 'short',
    });
    const dateStr = dateUtils.formatDayWithOrdinal(date);
    return monthStr + ' ' + dateStr;
  },
  currentMonth(): string {
    return new Date().toLocaleString('default', { month: 'long' });
  },
  previousMonth(): string {
    const d = new Date();
    d.setDate(1);
    d.setMonth(d.getMonth() - 1);
    return d.toLocaleString('default', { month: 'long' });
  },
  currentYear(): number {
    return new Date().getFullYear();
  },
  previousYear(): number {
    return this.currentYear() - 1;
  },
  displayDate(date: string | null): string | null {
    if (date) {
      const d = new Date(date);
      return d.toLocaleString('default', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
    }
    return null;
  },
};

export default dateUtils;
